import { colors, iconNew } from "@teamrota/rota-design";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  PlusIcon,
  StyledOpenShiftEmptyCard
} from "../../../GridCard/grid-card.styles";
import { OpenShiftDailyCard } from "../../OpenShiftDailyCard/open-shift-daily-card";
import {
  StyledBackButton,
  StyledCreateShiftContainer,
  StyledDailyView,
  StyledDayViewShiftsContainer,
  StyledDot,
  StyledOpenShiftsRow,
  StyledScrollContainer,
  StyledScrollControls
} from "~/src/containers/scheduler/OpenShifts/OpenShiftTableRow/DailyView/daily-view.styles";
import { SHIFT_TYPES } from "~/src/consts";

const { ChevronLeft, ChevronRight } = iconNew;

const DailyView = ({
  selectedDayIndex,
  unassignedShifts,
  setSelectedDayIndex,
  getInitialShiftData,
  getFifteenMinsInFuture,
  onPressShiftCell,
  assignMemberLoading
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [lastDraggedShiftId, setLastDraggedShiftId] = useState(null);

  const shiftsPageRef = useRef();
  const shiftsPageWidth = shiftsPageRef?.current?.clientWidth || 0;

  const dayShifts =
    selectedDayIndex !== null && unassignedShifts?.[selectedDayIndex]?.shifts
      ? unassignedShifts[selectedDayIndex].shifts.filter(
          shift => shift.type !== SHIFT_TYPES.NIGHT
        )
      : [];

  const nightShifts =
    selectedDayIndex !== null && unassignedShifts?.[selectedDayIndex]?.shifts
      ? unassignedShifts[selectedDayIndex].shifts.filter(
          shift => shift.type === SHIFT_TYPES.NIGHT
        )
      : [];

  const isCurrentDayInFuture =
    selectedDayIndex !== null &&
    unassignedShifts?.[selectedDayIndex]?.shifts &&
    moment(unassignedShifts[selectedDayIndex].date).isSameOrAfter(
      moment(),
      "day"
    );

  const getNumberOfpages = () =>
    Math.floor(Math.max(dayShifts.length, nightShifts.length) / 5) + 1;

  const nextPage = () => {
    const nextPageIndex =
      currentPage === getNumberOfpages() - 1 ? 0 : currentPage + 1;

    setCurrentPage(nextPageIndex);
  };

  const prevPage = () => {
    const prevPageIndex =
      currentPage === 0 ? getNumberOfpages() - 1 : currentPage - 1;

    setCurrentPage(prevPageIndex);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [selectedDayIndex]);

  return (
    <StyledDailyView>
      <StyledBackButton onClick={() => setSelectedDayIndex(null)} />

      {isCurrentDayInFuture && (
        <StyledCreateShiftContainer>
          <StyledOpenShiftEmptyCard
            lineHeight="4px"
            onClick={() =>
              unassignedShifts?.[selectedDayIndex]?.date &&
              getInitialShiftData(
                selectedDayIndex,
                getFifteenMinsInFuture(unassignedShifts[selectedDayIndex].date)
              )
            }
          >
            <PlusIcon name="PLUS" size="small" color={colors.rotaOrange} />
          </StyledOpenShiftEmptyCard>
        </StyledCreateShiftContainer>
      )}

      <StyledDayViewShiftsContainer ref={shiftsPageRef}>
        <StyledScrollContainer
          shiftsPageWidth={shiftsPageWidth}
          pageNumber={currentPage}
        >
          <StyledOpenShiftsRow>
            {dayShifts.map(shift => (
              <OpenShiftDailyCard
                key={shift.id}
                shift={shift}
                onPressShiftCell={onPressShiftCell}
                assignMemberLoading={assignMemberLoading}
                lastDraggedShiftId={lastDraggedShiftId}
                setLastDraggedShiftId={setLastDraggedShiftId}
              />
            ))}
          </StyledOpenShiftsRow>

          <StyledOpenShiftsRow>
            {nightShifts.map(shift => (
              <OpenShiftDailyCard
                key={shift.id}
                shift={shift}
                onPressShiftCell={onPressShiftCell}
                assignMemberLoading={assignMemberLoading}
                lastDraggedShiftId={lastDraggedShiftId}
                setLastDraggedShiftId={setLastDraggedShiftId}
              />
            ))}
          </StyledOpenShiftsRow>
        </StyledScrollContainer>

        {getNumberOfpages() > 1 && (
          <StyledScrollControls>
            <ChevronLeft onClick={prevPage} />
            {Array(getNumberOfpages())
              .fill(null)
              .map((_, i) => (
                <StyledDot
                  isActive={currentPage === i}
                  key={i}
                  onClick={() => setCurrentPage(i)}
                />
              ))}
            <ChevronRight onClick={nextPage} />
          </StyledScrollControls>
        )}
      </StyledDayViewShiftsContainer>
    </StyledDailyView>
  );
};

export default DailyView;
